export default __webpack_public_path__ + "static/media/infertility1.be482258.jpg";